<template>
  <div class="col-12 g">
    <div class="card card-body">
      <h4>إعدادات المساعد الذكي</h4>
      <hr>
      <div class="row">
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label>اسم المساعد</label>
            <input type="text" class="form-control" v-model="settings.bot_name" placeholder="سعود">
          </div>
        </div>
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label>اسم المطور</label>
            <input type="text" class="form-control" v-model="settings.developer_name" placeholder="التحضير الذكي">
          </div>
        </div>
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label>اسم النظام</label>
            <input type="text" class="form-control" v-model="settings.system_name" placeholder="تحضير">
          </div>
        </div>
        <div class="col-12 g">
          <div class="form-group">
            <label>تعليمات إضافية للمساعد</label>
            <textarea class="form-control" v-model="settings.extra_instructions" rows="6" placeholder="أضف هنا أي تعليمات إضافية تريد أن يتبعها المساعد..."></textarea>
            <small class="text-muted">مثال: لا ترد على أسئلة خارج نطاق النظام، استخدم لهجة رسمية، الخ</small>
          </div>
        </div>
        <div class="col-12 g">
          <div class="form-group">
            <label>قاعدة المعلومات</label>
            <textarea class="form-control" v-model="settings.knowledge_base" rows="12" placeholder="اترك فارغاً لاستخدام قاعدة المعلومات الافتراضية (ai_replies.txt)"></textarea>
            <small class="text-muted">المعلومات التي يستخدمها المساعد للإجابة على الأسئلة (أسعار، خدمات، شروحات). اتركه فارغاً لاستخدام الملف الافتراضي.</small>
          </div>
        </div>
        <div class="col-12 text-center g">
          <button class="btn btn-primary btn-lg" @click="save()" v-if="!saving">
            <i class="fa fa-save"></i>
            حفظ الإعدادات
          </button>
          <button class="btn btn-secondary btn-lg disabled" disabled v-if="saving">
            جاري الحفظ...
          </button>
        </div>
      </div>
    </div>

    <!-- the school app's support assistant (Nodejs src/support/ai.js) -->
    <div class="card card-body">
      <h4>الذكاء الاصطناعي للدعم (تطبيق المدرسة)</h4>
      <p class="text-muted mb-0">
        «المساعد الذكي» في صفحة الدعم الفني بتطبيق المدرسة. يرسل لكل سؤال جزءاً صغيراً من قاعدة المعلومات أعلاه (الأقرب للسؤال) بدل القاعدة كاملة، لتقليل استهلاك التوكنز.
      </p>
      <hr>
      <div class="row">
        <div class="col-12 col-lg-4 g">
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="sai-enabled" v-model="support.enabled">
            <label class="custom-control-label" for="sai-enabled">تفعيل المساعد في تطبيق المدرسة</label>
          </div>
        </div>
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label for="sai-cap">الحد اليومي للأسئلة لكل مدرسة</label>
            <input id="sai-cap" type="number" min="1" max="1000" class="form-control" v-model="support.daily_cap">
          </div>
        </div>
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label for="sai-token">توكن الذكاء الاصطناعي (brmja)</label>
            <input id="sai-token" type="password" dir="ltr" autocomplete="off" class="form-control" v-model="support.token" :placeholder="support.has_token ? 'محفوظ ' + support.token_hint + ' · اتركه فارغاً للإبقاء عليه' : 'الصق التوكن هنا'">
            <small class="text-muted" v-if="support.env_token">يُستخدم الآن التوكن من إعدادات السيرفر (BRMJA_AI_TOKEN).</small>
            <small v-if="support.has_token"><a href="javascript:;" class="text-danger" @click="clearToken()">حذف التوكن المحفوظ</a></small>
          </div>
        </div>
        <div class="col-12 g">
          <div class="form-group">
            <label for="sai-extra">تعليمات إضافية لمساعد الدعم (اختياري، 600 حرف)</label>
            <textarea id="sai-extra" class="form-control" v-model="support.extra" rows="3" maxlength="600" placeholder="مثال: عند أسئلة الأسعار وجّه المدرسة لصفحة الاشتراك في الخدمات"></textarea>
          </div>
        </div>
        <div class="col-12 text-center g">
          <button class="btn btn-primary" @click="saveSupport()" :disabled="savingSupport">
            <i class="fa fa-save"></i>
            حفظ إعدادات مساعد الدعم
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      savingSupport: false,
      support: { enabled: true, daily_cap: 40, extra: '', token: '', has_token: false, token_hint: '', env_token: false },
      settings: {
        bot_name: '',
        developer_name: '',
        system_name: '',
        extra_instructions: '',
        knowledge_base: ''
      }
    }
  },
  created() {
    this.load();
    this.loadSupport();
  },
  methods: {
    loadSupport() {
      var g = this;
      $.post(api + '/admin/support/ai', {
        jwt: localStorage.getItem('jwt')
      }).then(function(r) {
        if (r.status == 100) {
          g.support = Object.assign({}, r.response, { token: '' });
        }
      })
    },
    saveSupport(clear) {
      var g = this;
      g.savingSupport = true;
      $.post(api + '/admin/support/ai/update', {
        jwt: localStorage.getItem('jwt'),
        enabled: g.support.enabled,
        daily_cap: g.support.daily_cap,
        extra: g.support.extra,
        token: g.support.token,
        clear_token: clear === true
      }).then(function(r) {
        g.savingSupport = false;
        alert(r.status == 100 ? 'تم حفظ إعدادات مساعد الدعم' : r.response)
        g.loadSupport();
      }).fail(function() {
        g.savingSupport = false;
      })
    },
    clearToken() {
      if (confirm('حذف التوكن المحفوظ؟ سيتوقف المساعد حتى تضيف توكناً جديداً.')) {
        this.support.token = '';
        this.saveSupport(true);
      }
    },
    load() {
      var g = this;
      $.post(api + '/admin/ai-chats/settings', {
        jwt: localStorage.getItem('jwt')
      }).then(function(r) {
        if (r.status == 100) {
          g.settings = r.response;
        }
      })
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + '/admin/ai-chats/settings/update', {
        jwt: localStorage.getItem('jwt'),
        bot_name: g.settings.bot_name,
        developer_name: g.settings.developer_name,
        system_name: g.settings.system_name,
        extra_instructions: g.settings.extra_instructions,
        knowledge_base: g.settings.knowledge_base
      }).then(function(r) {
        g.saving = false;
        if (r.status == 100) {
          alert('تم حفظ الإعدادات بنجاح')
        } else {
          alert(r.response)
        }
      }).fail(function() {
        g.saving = false;
      })
    }
  }
}
</script>
